import Grid from "@mui/material/Grid2";
import Stack from "@mui/material/Stack";
import monthDropdown from "../Constants/MonthDropdown";
import yesNoDropdown from "../Constants/YesNoDropdown";
import RenderSelectField from "./RenderSelectField";
import RenderTextField from "./RenderTextField";
import { useFormContext, useWatch } from "react-hook-form";

interface IProps {
    name: string;
    label: string;
}
export default function RenderMonitoringReportFeatureRow({ name, label }: IProps) {
    const { control } = useFormContext();
    const value = useWatch({ control, name });
    return (
        <Stack direction="row" spacing={1}>
            <Grid size={6}>
                <RenderSelectField name={name} label={label} readOnly={true} options={yesNoDropdown} />
            </Grid>
            <Grid size={3}>
                <RenderSelectField name={`${name}Month`} options={monthDropdown} readOnly={true} alwaysShow={value != null} />
            </Grid>
            <Grid size={3}>
                <RenderTextField name={`${name}Year`} readOnly={true} alwaysShow={value != null} />
            </Grid>
        </Stack>
    )
};